import { Model } from 'infra/model'
import { PendingTeamMemberDTO } from 'iam/dtos/team-member'
import { Id } from 'types/definitions'
import { DateZero, maybeParseDate } from 'utils/date-util'
import TeamRole from './TeamRole'
import Team from './Team'
import { PrimeTeam } from 'iam/TeamStore'
import { PrimeTeamRole } from 'iam/TeamRoleStore'
import { computed, observable, makeObservable } from 'mobx'
import { generateAvatarFallback } from 'utils/image-util'

export default class PendingTeamMember extends Model<
  PendingTeamMemberDTO,
  PendingTeamMember
> {
  @observable workspaceId = Id.none
  @observable dateCreated: Date = DateZero()
  @observable dateModified: Date = DateZero()
  @observable email = ''
  @observable teamRole = TeamRole.none
  @observable expires: Date = DateZero()

  @observable team = Team.none

  constructor(
    private primeTeam: PrimeTeam,
    private primeTeamRole: PrimeTeamRole,
  ) {
    super()
    makeObservable(this)
  }

  @computed
  get avatar() {
    return generateAvatarFallback(
      this.email,
      this.team.workspace.branding.colors.primary,
    )
  }

  parse(json: Partial<PendingTeamMemberDTO>): Partial<PendingTeamMember> {
    return {
      workspaceId: json.workspace_id,
      dateCreated: maybeParseDate(json.date_created),
      dateModified: maybeParseDate(json.date_modified),
      email: json.email,
      team: this.primeTeam({
        id: json.team_id,
        workspace_id: json.workspace_id,
      }),
      teamRole: this.primeTeamRole({
        id: json.team_role_id,
        workspace_id: json.workspace_id,
      }),
      expires: maybeParseDate(json.expires),
    }
  }
}
